/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
const VIPRConfig = require('dashboard-analytics/visualizations/vipr/VIPRConfig');

function isExtVis(visId) {
	const viprConfig = VIPRConfig.getConfig(visId);
	if (viprConfig) {
		return viprConfig.isSchematic || viprConfig.isCustomVis;
	}
	return false;
}

/**
* Verifies if the passed object is a widget of type supported by Explore
* @param {object} spec - the Json spec of widget in question
* @param {boolean} markCustomVisWidget - option to mark the widget as customVis widget if it's the case (default=true)
*/
function isAcceptedLiveWidget(spec, markCustomVisWidget = true) {
	if (spec.type === 'live' || (spec.type === 'widget' && spec.widgetType === 'live')) {
		const isExtVisFlag = isExtVis(spec.visId);
		if (isExtVisFlag && markCustomVisWidget) {
			spec.isExtVis = true;
		}
		const UNSUPPORTED_VIS_NAMES = ['dataPlayer', 'dropdownList'];
		return !UNSUPPORTED_VIS_NAMES.includes(spec.visId) && !isExtVisFlag;
	}
	return false;
}

export { isExtVis, isAcceptedLiveWidget };



// WEBPACK FOOTER //
// ./src/js/util/ExtVisUtil.js